import { generalConstants } from '../constants';

const initialState = {
    studentStatusesLoading: 0,
	studentStatuses: {},

	supportedCurrenciesLoading: 0,
	supportedCurrencies: {},
	// Debug status
	debugMode: false
};

export default (state = initialState, payload) => {
	const { type, data } = payload;
	switch (type) {
		// Load student statuses
		case generalConstants.LOAD_STUDENT_STATUS_REQUEST:
			return {
				...state,
				studentStatusesLoading: state.studentStatusesLoading + 1
			};
		case generalConstants.LOAD_STUDENT_STATUS_SUCCESS:
			return {
				...state,
				studentStatusesLoading: state.studentStatusesLoading - 1,
				studentStatuses: data
			};
		case generalConstants.LOAD_STUDENT_STATUS_FAILURE:	
			return {
				...state,
				studentStatusesLoading: state.studentStatusesLoading - 1
			};
		// Load supported currencies
		case generalConstants.LOAD_SUPPORTED_CURRENCIES_REQUEST:
			return {
				...state,
				supportedCurrenciesLoading: state.supportedCurrenciesLoading + 1
			};
		case generalConstants.LOAD_SUPPORTED_CURRENCIES_SUCCESS:
			return {
				...state,
				supportedCurrenciesLoading: state.supportedCurrenciesLoading - 1,
				supportedCurrencies: data
			};
		case generalConstants.LOAD_SUPPORTED_CURRENCIES_FAILURE:	
			return {
				...state,
				supportedCurrenciesLoading: state.supportedCurrenciesLoading - 1
			};
		case generalConstants.SET_DEBUG_STATUS:
			return {
				...state,
				debugMode: data
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/redux/reducers/general.reducers.js